import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { mdiMapMarkerQuestionOutline } from "@mdi/js";

import { DffSideModule, EmptyPageBadgeModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";

import { Error404RoutingModule } from "./error404-routing.module";
import { Error404Component } from "./error404.component";

@NgModule({
    imports: [CommonModule, Error404RoutingModule, EmptyPageBadgeModule, DffSideModule],
    exports: [],
    declarations: [Error404Component],
    providers: []
})
export class EForsyningFeaturesError404Module {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiMapMarkerQuestionOutline, "404");
    }
}
